<template>
  <p class="text-xs opacity-75 mt-2">{{ $t("pricing.includes_tax") }}</p>
</template>
